module.exports = __webpack_public_path__ + "img/401-V01-02.5f2fc00d.png";